var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    margintop: "10px",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.564 10c0-.667-.533-1.467-1.133-1.667-.6-.2-1.2-.733-1.4-1.2-.134-.4-.134-1.2.2-1.8.266-.6.133-1.466-.4-1.933-.467-.467-1.4-.667-1.934-.4-.6.333-1.4.333-1.866.2-.4-.2-.934-.8-1.2-1.4-.134-.667-.934-1.133-1.6-1.133-.667 0-1.467.466-1.667 1.133-.2.6-.733 1.2-1.2 1.4-.4.133-1.2.133-1.8-.2-.533-.267-1.467-.067-1.933.4-.467.467-.667 1.4-.4 1.933.333.6.333 1.4.2 1.867-.2.4-.8.933-1.4 1.2-.6.267-1.134.933-1.134 1.6s.467 1.467 1.134 1.667c.6.2 1.2.733 1.4 1.2.133.4.133 1.2-.2 1.8-.334.6-.134 1.466.4 1.933.466.467 1.4.667 1.933.4.6-.267 1.4-.333 1.8-.133.4.2.933.8 1.2 1.4.2.6 1 1.066 1.667 1.066.666 0 1.466-.466 1.666-1.133.2-.6.734-1.2 1.2-1.4.4-.2 1.2-.133 1.8.133.6.267 1.467.134 1.934-.4.466-.466.666-1.4.4-1.933-.267-.6-.334-1.4-.134-1.8.2-.4.8-.933 1.4-1.2.6-.133 1.067-.933 1.067-1.6Zm-9.333 3.4a3.414 3.414 0 0 1-3.4-3.4c0-1.867 1.533-3.4 3.4-3.4 1.866 0 3.4 1.533 3.4 3.4s-1.534 3.4-3.4 3.4Z",
    fill: "#969494",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.76286588ce5edaed18480f25cae03b2a.svg";
export { ForwardRef as ReactComponent };